import React, { Component } from 'react';
import image from '../../assets/img/vector/video_vigilancia.svg';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';
import ImageText from '../../subcomponents/ImageText';
import TextImage from '../../subcomponents/TextImage';
import imgBody1 from '../../assets/img/contenido/hikvision2.png';
import imgBody2 from '../../assets/img/contenido/vigilancia.jpg';
import img1 from '../../assets/img/flat/vigilancia1.svg';
import img2 from '../../assets/img/flat/vigilancia2.svg';
import img3 from '../../assets/img/flat/vigilancia3.svg';
import IconBlock from '../../subcomponents/IconBlock28';
import hikvision from '../../assets/img/brand/hikvision.png';

class VigilanciaIp extends Component {
  componentDidMount() {
    document.title = 'Vigilancia IP - Insacom';
  }

  render() {
    const content = [
      {
        id: 1,
        title: 'Convergente',
        description: 'Integramos sistema de vigilancia a su red IP existente',
        img: img1
      },
      {
        id: 2,
        title: '24/7',
        description: 'Acceso en cualquier momento y desde cualquier lugar',
        img: img2
      },
      {
        id: 3,
        title: 'Más por Menos',
        description: 'Alta calidad de imagen, con el menor uso de almacenamiento',
        img: img3
      }
    ];

    const descripcion =
      'Visualice en tiempo real y desde cualquier parte del mundo su empresa, bodegas e instalaciones. Modernice su sistema de seguridad con sistemas de video que permitirán vigilar en todo momento con el mejor retorno de inversión.';

    return (
      <Section asuntoContacto={'Vigilancia IP'}>
        <SectionContainer grey paddingBottom={'0px'}>
          <ImageText image={image} title="VideoVigilancia IP" description={descripcion}>
            <div className="d-flex justify-content-between flex-wrap">
              <div className="align-self-center">
                <img src={hikvision} alt="HIKVISION" style={{ height: '65px', paddingBottom: 20 }}></img>
              </div>
            </div>
          </ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock version={1} content={content}></IconBlock>
        </SectionContainer>
        <SectionContainer grey>
          <TextImage image={imgBody1} title="Características">
            <ul className="list-unstyled mb-0">
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Diseño en base a requerimientos.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Amplia variedad de soluciones para distintas verticales de mercado.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Implementación de sala de monitoreo CCTV.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Alta calidad de video.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Gestión centralizada.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Alta disponibilidad.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Soporte y mantenimiento de sistemas de CCTV.
                </p>
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
        <SectionContainer>
          <ImageText image={imgBody2}>
            <p className="lead">
              No todo es seguridad, también puede aprovechar las tecnologías de procesamiento de
              video para monitoreo de procesos industriales, medicion de temperatura para múltiples
              propósitos, e incluso realizar analisis de mercadeo para salas de venta.
            </p>
          </ImageText>
        </SectionContainer>
      </Section>
    );
  }
}

export default VigilanciaIp;



// WEBPACK FOOTER //
// ./src/sections/proyectos/VigilanciaIp.js